import { useState, useEffect } from "react";

const useAuth = () => {
  const [user, setUser] = useState(localStorage.getItem("authToken") || null);

  useEffect(() => {
    const access_token = localStorage.getItem("authToken");
    if (access_token) {
      setUser({ access_token });
    }
  }, []);

  const login = (access_token) => {
    localStorage.setItem("authToken", access_token);
    setUser({ access_token });
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("taskConsts");
    localStorage.removeItem("org");
    localStorage.removeItem("user");
    setUser(null);
  };

  return { user, login, logout };
};

export default useAuth;
